export default __webpack_public_path__ + "static/media/welpentreffen_25.ad8e3ea4.jpg";